export const varietyShows = [
  {
    id: 'variety-01',
    title: 'Running Man',
    originalTitle: '런닝맨',
    type: 'variety',
    region: 'kr',
    year: 2010,
    genre: '真人秀 / 竞技',
    subtitleStatus: 'completed',
    tags: ['韩综', '竞技', '笑点', '长寿节目'],
    updatedAt: '2026-10-09',
    popularity: 10260,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20energetic%20reality%20game%20variety%20show%2C%20colorful%20running%20figures%20silhouettes%20through%20a%20bright%20city%20playground%2C%20vivid%20coral%20orange%20and%20deep%20blue%20tones%2C%20playful%20fun%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-01&orientation=portrait',
    description: '固定成员与嘉宾组队闯关竞赛，用体力与脑力在游戏中争夺最终胜利。',
    synopsis: '作为长寿综艺的代表，成员们每周在城市与主题场景中完成各式任务，从撕名牌追逐到烧脑推理。团队默契与互相“背叛”的笑料，构成了这档节目经久不衰的魅力。',
    subtitleNote: '字幕组长期稳定更新，涵盖完整成员介绍、游戏规则字幕与流行语注释，更新及时。',
    subtitleVersions: [
      { id: 'variety-01-v1', language: '简体中文', team: '长跑字幕组', format: 'ASS', publishedAt: '2026-10-09', note: '含流行语注释' },
      { id: 'variety-01-v2', language: '繁体中文', team: '长跑字幕组', format: 'SRT', publishedAt: '2026-10-02' },
    ],
  },
  {
    id: 'variety-02',
    title: '认识的哥哥',
    originalTitle: '아는 형님',
    type: 'variety',
    region: 'kr',
    year: 2015,
    genre: '访谈 / 喜剧',
    subtitleStatus: 'completed',
    tags: ['韩综', '访谈', '喜剧', '脱口秀'],
    updatedAt: '2026-10-07',
    popularity: 8740,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20comedy%20talk%20variety%20show%2C%20friendly%20seated%20figures%20silhouettes%20in%20a%20warm%20classroom%20setting%2C%20warm%20amber%20and%20soft%20teal%20tones%2C%20cheerful%20cozy%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-02&orientation=portrait',
    description: '以“转学生”之名迎来嘉宾，在教室设定里展开幽默又走心的访谈问答。',
    synopsis: '节目把演播厅布置成一间教室，主持人化身“哥哥”们。每期邀请不同嘉宾以转学生身份登场，在轻松的提问与游戏环节中展现明星不为人知的一面，笑点与温情并存。',
    subtitleNote: '字幕组对嘉宾梗与圈内流行语做了背景补充，方便新观众快速跟上笑点节奏。',
    subtitleVersions: [
      { id: 'variety-02-v1', language: '简体中文', team: '教室字幕组', format: 'ASS', publishedAt: '2026-10-07' },
      { id: 'variety-02-v2', language: '中韩双语', team: '教室字幕组', format: 'ASS', publishedAt: '2026-09-18' },
    ],
  },
  {
    id: 'variety-03',
    title: '街舞女战士 第2季',
    originalTitle: '스트리트 우먼 파이터2',
    type: 'variety',
    region: 'kr',
    year: 2023,
    genre: '舞蹈 / 竞技',
    subtitleStatus: 'completed',
    tags: ['舞蹈', '竞技', '舞台', '燃'],
    updatedAt: '2026-10-03',
    popularity: 8360,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Korean%20street%20dance%20competition%20variety%20show%2C%20dynamic%20dancer%20silhouettes%20mid%20move%20under%20dramatic%20stage%20spotlights%2C%20vivid%20magenta%20amber%20and%20deep%20blue%20tones%2C%20high%20energy%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-03&orientation=portrait',
    description: '顶尖女子舞团同台竞技，用编舞与舞台表现力决出最强舞团。',
    synopsis: '来自世界各地的女子舞蹈团队在节目中展开对决，从街头斗舞到大型舞台竞演。她们用汗水与创意编排每一场表演，在激烈的竞演中争取属于自己的高光时刻。',
    subtitleNote: '字幕组为舞蹈术语与舞台介绍提供了专业译名，并保留背景音乐的曲目信息。',
    subtitleVersions: [
      { id: 'variety-03-v1', language: '简体中文', team: '节拍字幕组', format: 'ASS', publishedAt: '2026-10-03', note: '含曲目信息' },
      { id: 'variety-03-v2', language: '繁体中文', team: '节拍字幕组', format: 'SRT', publishedAt: '2026-09-12' },
    ],
  },
  {
    id: 'variety-04',
    title: '尹食堂 第2季',
    originalTitle: '윤식당2',
    type: 'variety',
    region: 'kr',
    year: 2018,
    genre: '真人秀 / 美食',
    subtitleStatus: 'completed',
    tags: ['美食', '旅行', '治愈', '慢综艺'],
    updatedAt: '2026-09-29',
    popularity: 7920,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20cozy%20Korean%20travel%20food%20reality%20variety%20show%2C%20a%20small%20seaside%20restaurant%20terrace%20at%20sunset%20with%20warm%20lanterns%2C%20rich%20amber%20and%20soft%20sage%20green%20tones%2C%20warm%20welcoming%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-04&orientation=portrait',
    description: '明星们在异国小镇经营一家韩式小食堂，用美食招待旅途中相遇的客人。',
    synopsis: '成员们来到风景宜人的海外小镇，开起一家只做几道拿手菜的韩式餐馆。从采购、备料到招待客人，他们在忙碌与笑声中感受慢节奏的生活，也收获旅途中的温暖相遇。',
    subtitleNote: '字幕组为菜单与外语对话提供双语对照，并补充了拍摄地的旅行小贴士。',
    subtitleVersions: [
      { id: 'variety-04-v1', language: '简体中文', team: '暖阳字幕组', format: 'SRT', publishedAt: '2026-09-29' },
      { id: 'variety-04-v2', language: '中韩双语', team: '暖阳字幕组', format: 'ASS', publishedAt: '2026-08-20' },
    ],
  },
  {
    id: 'variety-05',
    title: '一日三餐 渔村篇',
    originalTitle: '삼시세끼 어촌편',
    type: 'variety',
    region: 'kr',
    year: 2015,
    genre: '真人秀 / 美食',
    subtitleStatus: 'completed',
    tags: ['慢综艺', '美食', '治愈', '乡村'],
    updatedAt: '2026-09-24',
    popularity: 7140,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20calm%20Korean%20countryside%20cooking%20reality%20variety%20show%2C%20a%20rustic%20seaside%20cottage%20with%20smoke%20from%20a%20chimney%20at%20dawn%2C%20muted%20sage%20green%20and%20warm%20amber%20tones%2C%20peaceful%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-05&orientation=portrait',
    description: '在偏远渔村自给自足，用亲手捕捞与种植的食材做出一日三餐。',
    synopsis: '成员们住进淳朴的渔村小屋，一切食材都要靠自己动手获取。他们从忐忑的第一次下厨，到默契地配合出一桌家常菜，在柴米油盐里体会最简单踏实的生活。',
    subtitleNote: '字幕组为乡土料理与地方方言提供注释，并整理了每道菜的做法要点。',
    subtitleVersions: [
      { id: 'variety-05-v1', language: '简体中文', team: '烟火字幕组', format: 'SRT', publishedAt: '2026-09-24' },
      { id: 'variety-05-v2', language: '繁体中文', team: '烟火字幕组', format: 'SRT', publishedAt: '2026-08-06' },
    ],
  },
  {
    id: 'variety-06',
    title: '我独自生活',
    originalTitle: '나 혼자 산다',
    type: 'variety',
    region: 'kr',
    year: 2013,
    genre: '真人秀 / 生活',
    subtitleStatus: 'completed',
    tags: ['独居', '生活', '治愈', '观察'],
    updatedAt: '2026-09-19',
    popularity: 8080,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20warm%20Korean%20solo%20living%20observation%20reality%20variety%20show%2C%20a%20single%20person%20silhouette%20relaxing%20in%20a%20cozy%20apartment%20with%20movie%20projector%20glow%2C%20soft%20amber%20and%20muted%20teal%20tones%2C%20intimate%20calm%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-06&orientation=portrait',
    description: '明星公开自己的独居日常，在镜头前呈现最真实的生活状态与小心思。',
    synopsis: '节目以观察类真人秀的形式，记录演艺明星独居生活的点滴。从烹饪、收拾房间到深夜的自我对话，观众得以窥见他们卸下光环后，同样平凡又可爱的一面。',
    subtitleNote: '字幕组为生活场景中的字幕与道具说明做了补充，并标注了嘉宾的职业信息。',
    subtitleVersions: [
      { id: 'variety-06-v1', language: '简体中文', team: '独居字幕组', format: 'ASS', publishedAt: '2026-09-19' },
      { id: 'variety-06-v2', language: '中韩双语', team: '独居字幕组', format: 'ASS', publishedAt: '2026-08-30' },
    ],
  },
  {
    id: 'variety-07',
    title: '新西游记',
    originalTitle: '신서유기',
    type: 'variety',
    region: 'kr',
    year: 2015,
    genre: '真人秀 / 旅行',
    subtitleStatus: 'completed',
    tags: ['旅行', '搞笑', '游戏', '长篇'],
    updatedAt: '2026-09-14',
    popularity: 8560,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20zany%20Korean%20travel%20game%20variety%20show%2C%20playful%20travelers%20silhouettes%20with%20luggage%20on%20an%20ancient%20city%20street%2C%20vivid%20coral%20orange%20and%20deep%20indigo%20tones%2C%20mischievous%20fun%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-07&orientation=portrait',
    description: '成员们化身取经人，在异国旅行途中完成各种爆笑任务与惩罚挑战。',
    synopsis: '以古典名著为灵感的旅行综艺，成员们背着行囊穿梭于中国、越南等地的街头。为了赢得奖励、逃避惩罚，他们花样百出，笑料与意外接连不断。',
    subtitleNote: '字幕组对多种方言与外语单词做了细致处理，并补充了游戏规则与惩罚说明。',
    subtitleVersions: [
      { id: 'variety-07-v1', language: '简体中文', team: '取经字幕组', format: 'ASS', publishedAt: '2026-09-14', note: '含游戏说明' },
      { id: 'variety-07-v2', language: '繁体中文', team: '取经字幕组', format: 'SRT', publishedAt: '2026-07-27' },
    ],
  },
  {
    id: 'variety-08',
    title: '闲着干嘛呢',
    originalTitle: '놀면 뭐하니?',
    type: 'variety',
    region: 'kr',
    year: 2019,
    genre: '真人秀 / 音乐',
    subtitleStatus: 'in-progress',
    tags: ['音乐', '企划', '搞笑', '创意'],
    updatedAt: '2026-10-11',
    popularity: 7880,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20creative%20Korean%20music%20project%20variety%20show%2C%20a%20vintage%20microphone%20and%20stage%20lights%20with%20silhouettes%20of%20musicians%2C%20warm%20amber%20and%20electric%20teal%20tones%2C%20retro%20playful%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-08&orientation=portrait',
    description: '以一句“闲着也是闲着”为起点，主持人不断尝试各种脑洞企划与音乐项目。',
    synopsis: '节目围绕主持人刘在石展开，每期推出不同身份与企划：从组建限定乐队到挑战全新职业。创意十足的设定与真诚的化学反应，让它成为拥有大量忠实观众的常青综艺。',
    subtitleNote: '制作组正在同步校对音乐企划部分的歌词字幕，热门曲目将追加中文翻译版本。',
    subtitleVersions: [
      { id: 'variety-08-v1', language: '简体中文', team: '闲不住字幕组', format: 'ASS', publishedAt: '2026-10-11', note: '歌词校对中' },
    ],
  },
  {
    id: 'variety-09',
    title: '交给岚吧',
    originalTitle: '嵐にしやがれ',
    type: 'variety',
    region: 'jp',
    year: 2010,
    genre: '综艺 / 访谈',
    subtitleStatus: 'completed',
    tags: ['日综', '偶像', '访谈', '经典'],
    updatedAt: '2026-09-08',
    popularity: 7080,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20retro%20Japanese%20idol%20talk%20variety%20show%2C%20a%20warm%20studio%20stage%20with%20five%20seated%20silhouettes%20and%20vintage%20neon%20signs%2C%20warm%20amber%20and%20soft%20teal%20tones%2C%20lively%20friendly%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-09&orientation=portrait',
    description: '人气团体以轻松姿态迎接各路来宾，用游戏与谈天展现偶像的另一面。',
    synopsis: '节目由人气偶像团体主持，围绕交友与谈话展开。每期设置不同主题，从成员之间的默契考验到与来宾的趣味对谈，既能看到偶像的成长，也能感受到他们真挚的默契。',
    subtitleNote: '字幕组为日本娱乐梗与偶像圈术语提供了背景解说，并统一了成员译名。',
    subtitleVersions: [
      { id: 'variety-09-v1', language: '简体中文', team: '岚友字幕组', format: 'ASS', publishedAt: '2026-09-08' },
      { id: 'variety-09-v2', language: '中日双语', team: '岚友字幕组', format: 'ASS', publishedAt: '2026-07-22' },
    ],
  },
  {
    id: 'variety-10',
    title: 'VS 岚 铁腕挑战',
    originalTitle: 'VS嵐',
    type: 'variety',
    region: 'jp',
    year: 2008,
    genre: '综艺 / 游戏',
    subtitleStatus: 'completed',
    tags: ['日综', '游戏', '竞技', '经典'],
    updatedAt: '2026-09-01',
    popularity: 6720,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Japanese%20game%20competition%20variety%20show%2C%20a%20colorful%20obstacle%20course%20with%20competing%20team%20silhouettes%20under%20bright%20lights%2C%20vivid%20coral%20orange%20and%20sky%20teal%20tones%2C%20upbeat%20energetic%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-10&orientation=portrait',
    description: '偶像团队与各界来宾分组闯关，在趣味游戏对决中一较高下。',
    synopsis: '节目以团队对抗为核心，来宾与固定成员组成队伍，挑战各式各样的游戏关卡。胜负之外，成员间的配合与临场反应才是最大看点，常常诞生令人捧腹的名场面。',
    subtitleNote: '字幕组对游戏计分规则与关卡名称做了统一翻译，并标注每轮胜负结果。',
    subtitleVersions: [
      { id: 'variety-10-v1', language: '简体中文', team: '通关字幕组', format: 'SRT', publishedAt: '2026-09-01' },
      { id: 'variety-10-v2', language: '繁体中文', team: '通关字幕组', format: 'SRT', publishedAt: '2026-07-10' },
    ],
  },
  {
    id: 'variety-11',
    title: '月曜夜未央',
    originalTitle: '月曜から夜ふかし',
    type: 'variety',
    region: 'jp',
    year: 2012,
    genre: '综艺 / 街访',
    subtitleStatus: 'completed',
    tags: ['日综', '街访', '幽默', '都市'],
    updatedAt: '2026-08-24',
    popularity: 7480,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20quirky%20Japanese%20late%20night%20street%20interview%20variety%20show%2C%20neon%20lit%20city%20alley%20with%20a%20reporter%20silhouette%20and%20microphone%2C%20deep%20indigo%20and%20warm%20amber%20neon%20tones%2C%20humorous%20urban%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-11&orientation=portrait',
    description: '深夜走上街头，用随机的采访与冷幽默挖掘普通人生活里的奇闻趣事。',
    synopsis: '节目以深夜街访与生活调查为主线，主持人追踪城市里各式各样的“小谜团”。看似琐碎的日常，在敏锐的视角与幽默的剪辑下，被讲成一段段耐人寻味的小故事。',
    subtitleNote: '字幕组为方言口音与街头文化用语做了注释，保留了原节目标志性的“不要学”提示。',
    subtitleVersions: [
      { id: 'variety-11-v1', language: '简体中文', team: '夜行字幕组', format: 'ASS', publishedAt: '2026-08-24' },
      { id: 'variety-11-v2', language: '中日双语', team: '夜行字幕组', format: 'ASS', publishedAt: '2026-07-01' },
    ],
  },
  {
    id: 'variety-12',
    title: '全员逃走中',
    originalTitle: 'run for money 逃走中',
    type: 'variety',
    region: 'jp',
    year: 2004,
    genre: '综艺 / 竞技',
    subtitleStatus: 'in-progress',
    tags: ['日综', '逃亡', '竞技', '刺激'],
    updatedAt: '2026-10-06',
    popularity: 6940,
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20artwork%20for%20a%20Japanese%20survival%20chase%20game%20variety%20show%2C%20fleeing%20runner%20silhouettes%20through%20a%20dramatic%20city%20arena%20with%20searchlights%2C%20deep%20crimson%20and%20cold%20teal%20with%20warm%20amber%20flashes%2C%20tension%20filled%20atmosphere%2C%20abstract%20graphic%20overlays%2C%20no%20text%2C%20refined%20editorial%20composition%2C%20high%20detail%2C%20premium%20poster%20aesthetic&width=600&height=900&seq=poster-variety-12&orientation=portrait',
    description: '被“猎人”追捕的参与者必须坚持到最后，逃亡越多时间，奖金越丰厚。',
    synopsis: '参与者在限定区域内不断躲避猎人追捕，坚持越久累积的奖金越高，也可以选择中途“自首”落袋为安。紧张刺激的规则与广阔的场景布置，造就了无数经典逃名场面。',
    subtitleNote: '制作组正在校对规则字幕与参与者的心理独白，计划追加猎人出没位置的提示标注。',
    subtitleVersions: [
      { id: 'variety-12-v1', language: '简体中文', team: '逃亡字幕组', format: 'SRT', publishedAt: '2026-10-06', note: '校对中' },
    ],
  },
];